
import { Toaster as Sonner } from "sonner"
import { cn } from "@/lib/utils"
import { useIsMobile } from "@/hooks/use-mobile"

type ToasterProps = React.ComponentProps<typeof Sonner>

export function Toaster({ ...props }: ToasterProps) {
  const isMobile = useIsMobile();
  
  return (
    <Sonner
      className={cn("toaster group")}
      position={isMobile ? "top-center" : "bottom-right"}
      toastOptions={{
        classNames: {
          toast: cn(
            "group toast",
            "bg-card/95 dark:bg-card/95",
            "backdrop-blur-xl border border-border",
            "shadow-2xl shadow-black/20",
            isMobile && "mt-safe"
          ),
          title: "text-foreground font-semibold text-sm",
          description: "text-muted-foreground text-xs",
          actionButton: "bg-primary hover:bg-primary/90 text-primary-foreground font-medium text-xs px-3 py-1.5 rounded-md",
          cancelButton: "bg-muted hover:bg-muted/80 text-muted-foreground text-xs px-3 py-1.5 rounded-md",
          closeButton: cn(
            "!bg-muted/50 !border-border hover:!bg-muted",
            "!text-foreground",
            "transition-all duration-200"
          ),
          success: "!border-primary/50 !bg-primary/10 [&>svg]:!text-primary",
          error: "!border-destructive/50 !bg-destructive/10 [&>svg]:!text-destructive",
          warning: "!border-[hsl(var(--color-warning))]/50 !bg-[hsl(var(--color-warning))]/10 [&>svg]:!text-[hsl(var(--color-warning))]",
          info: "!border-primary/50 !bg-primary/10 [&>svg]:!text-primary",
        },
        duration: 4000,
      }}
      richColors={false}
      expand={isMobile}
      visibleToasts={isMobile ? 2 : 4}
      closeButton={true}
      {...props}
    />
  )
}
